import PaymentIcon from "@material-ui/icons/Payment";
import { IRoute } from "src/common/typings/routes";
import { QuickPayList } from "./pages/ListOfQuickPay";
import { SchedulingModule } from "./quickPayModule";

export const QuickPayRoute: IRoute = {
  title: "QuickPay",
  path: "/quick-pay",
  icon: PaymentIcon,
  component: SchedulingModule,
  subRoutes: [
    {
      component: QuickPayList,
      path: "/list-quick-pay",
      title: "List of QuickPay",
    },
  ],
};
